import React from 'react';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  BarChart,
  Bar,
  Legend,
  Brush,
  ResponsiveContainer,
} from 'recharts';
import EmptyState from '../EmptyState';
import { getNumberWithCommas } from '../../utilities/money';
import { CHAIN_COLORS } from '../../constants/chain_colors';
import { stringToColour } from '../../utilities/generateColorFromString';
import { EXCHANGES } from '../../constants/exchange';
import { useLocation } from 'react-router-dom';

const BarChartComponent = (props) => {
  const { data, chains, direction } = props;

  // Dynamically set the width for the graph as per data size
  const width =
    data.length && data.length < 5
      ? 600
      : data.length < 6
      ? 900
      : data.length < 9
      ? 1000
      : data.length < 12
      ? 1200
      : 1600;

  const CustomizedTooltip = (value, name, props) => {
    return `$ ${getNumberWithCommas(value)}`;
  };

  /* const renderCustomizedLabel = (props) => {
    const { x, y, width, value } = props;
    const radius = 15;
    return (
      <g>
        <circle cx={x + width / 2} cy={y - radius} r={radius} fill="#8884d8" />
        <text
          x={x + width / 2}
          y={y - radius}
          fill="#fff"
          textAnchor="middle"
          dominantBaseline="middle"
          width={5}
        >
          {value}
        </text>
      </g>
    );
  };
  */

  // Calculated end Index by 40% of total data length
  const endIndex =
    data.length < 30
      ? Math.round(data.length * 0.7)
      : data.length < 50
      ? Math.round(data.length * 0.4)
      : 14;

  const tickFormatter = (value) => {
    const limit = 7; // put your maximum character
    let finalValue = value.toString();
    if (finalValue.length < limit) return value;
    return `${finalValue.substr(0, finalValue.length - 3)}K`;
  };

  const verticalTickFormatter = (value) => {
    // const limit = 7; // put your maximum character
    // let finalValue = value.toString();
    // if (finalValue.length < limit) return value;
    // return `${finalValue.substr(0, finalValue.length - 3)}K`;

    // let mainValue = ""
    // for (let index = 1; index < value.length; index++) {
    //   const element = value[index];
    //   const checkUppercase = () => {
    //     if (element === element.toUpperCase()) {
    //       return ` ${element}`
    //     }
    //     return element
    //   }
    //   let result = text1.concat(" ", text2);

    // }

    if (value) {
      const result = value.match(/.{1,6}/g);
      return result[1] ? result[0].concat(' ', result[1]) : result[0];
    }
    return value;
  };

  const legendLength = () => {
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      return Object.keys(element).length - 1;
    }
  };

  const legendLeftMarg = legendLength() === 2 ? 50 : legendLength() === 1 ? '22%' : 60;

  const emptArr = [
    { value: 0, name: '' },
    { value: 0, name: '' },
  ];

  const renderTooltip = ({ active, payload, label }) => {
    // const nonZeroValue = () => {

    //   for (let index = 0; index < payload.length; index++) {
    //     const element = payload[index];
    //     const getObject = Object.values(element)
    //     return getObject[8];
    //   }
    // }


    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <div
            // key={`item-${index}`}
            className="custom_tooltip_head"
            style={{ marginRight: '20px', width: '100%', listStyleType: 'none' }}
          >
            <p className="label">{`${label}`}</p>
            {payload.map((item, index) => {
              return (
                item.value !== 0 && (
                  <span
                    className="custom_tooltip"
                    style={{
                      color: CHAIN_COLORS[item.dataKey]
                        ? CHAIN_COLORS[item.dataKey]
                        : stringToColour(item.dataKey),
                    }}
                  >
                    <span>{item.dataKey} : &nbsp; </span>
                    <span>${item.value.toFixed(4)}</span>
                  </span>
                )
              );
            })}
          </div>
        </div>
      );
    }

    return null;
  };

  const location = useLocation();
  const currentPageUrl = location.pathname;

  const exchangeLegendFormatter = (value, entry) => {
    return (
      <span style={{ color: ' rgb(38, 171, 164)' }}>
        {EXCHANGES?.[value.replaceAll(/\s/g, '').toLowerCase()].toUpperCase()}
      </span>
    );
  };

  const legendFormatter = (value, entry) => {
    return <span style={{ color: ' rgb(38, 171, 164)' }}>{value?.toUpperCase()}</span>;
  };

  return (
    <>
      {data ? (
        <ResponsiveContainer
          height={direction === 'vertical' && endIndex > 10 ? 700 : 430}
          width="100%"
        >
          <BarChart
            width={width}
            height={300}
            data={data.length < 3 ? data.concat(emptArr) : data}
            reverseStackOrder={false}
            layout={direction === 'vertical' ? 'vertical' : 'horizontal'}
            margin={{ top: 5, right: 30, bottom: 0, left: 0 }}
            label={{ fill: 'red', fontSize: 20 }}
          >
            {endIndex > 4 && (
              <Brush
                dataKey="name"
                height={20}
                startIndex={0}
                endIndex={endIndex}
                stroke="#8884d8"
              />
            )}
            <CartesianGrid strokeDasharray="2,5" />
            {direction === 'vertical' ? (
              <>
                <XAxis type="number" />
                <YAxis
                  type="category"
                  dataKey="name"
                  tick={true}
                  tickFormatter={verticalTickFormatter}
                  tickSize={3}
                />
              </>
            ) : (
              <>
                <XAxis type="category" dataKey="name" tick={true} />
                <YAxis tickFormatter={tickFormatter} />
              </>
            )}
            <Tooltip
              labelClassName={direction === 'vertical' ? 'verticalTool' : null}
              isAnimationActive={false}
              cursor={false}
              formatter={CustomizedTooltip}
              allowEscapeViewBox={{ y: true }}
              content={renderTooltip}
              wrapperStyle={{
                top: direction === 'vertical' ? '5%' : '-20%',
                left: '3%',
                zIndex: 1,
              }}
            />

            {currentPageUrl === '/exchanges/overview' ? (
              <Legend
                formatter={exchangeLegendFormatter}
                width={'92%'}
                align={legendLength() > 3 ? 'left' : 'center'}
                wrapperStyle={{ position: 'absolute', left: legendLeftMarg }}
              />
            ) : (
              <Legend
                width={'92%'}
                formatter={legendFormatter}
                align={legendLength() > 3 ? 'left' : 'center'}
                wrapperStyle={{ position: 'absolute', left: legendLeftMarg }}
              />
            )}
            {chains &&
              chains.length > 0 &&
              chains.map((chain, index) => {
                return (
                  <Bar
                    isAnimationActive={false}
                    key={index}
                    dataKey={chain}
                    stackId="a"
                    maxBarSize={20}
                    minPointSize={0.5}
                    fill={
                      CHAIN_COLORS[chain]
                        ? CHAIN_COLORS[chain]
                        : stringToColour(chain.toLowerCase())
                    }
                  />
                );
              })}
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <EmptyState />
      )}
    </>
  );
};

export default BarChartComponent;
